const axios = require('axios');

axios.interceptors.request.use(config => {
  const token = localStorage.getItem('jwtToken');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
}, error => {
  return Promise.reject(error);
});



export function generateObjectId() {
  const timestamp = Math.floor(new Date().getTime() / 1000).toString(16);
  const random = 'xxxxxxxxxxxxxxxx'.replace(/[x]/g, () => (Math.random() * 16 | 0).toString(16)).toLowerCase();
  return timestamp + random;
}

axios.interceptors.response.use(
  response => response,
  async error => {
    const originalRequest = error.config;

    console.log(error.response?.status, originalRequest._retry, 'error.response?.status')

    // Проверяем, что это ошибка 401 и запрос ещё не был повторён
    if (error.response?.status === 401 && !originalRequest._retry) {
      const refreshToken = localStorage.getItem('refreshToken');


      if (refreshToken) {
        originalRequest._retry = true;
        try {
          const res = await axios.post(`https://stroybots-firebase-mongo-web.stroybots.ru/api/v1/auth/refresh/`, {
            refreshToken: refreshToken
          });

          const newAccessToken = res.data.token;
          const newRefreshoken = res.data.refreshToken
          // Сохраняем новый токен
          localStorage.setItem('jwtToken', newAccessToken);
          localStorage.setItem('refreshToken', newRefreshoken);
          // Обновляем заголовок и повторяем запрос
          console.log(res, 'res')
          originalRequest.headers['Authorization'] = 'Bearer ' + newAccessToken;
          return axios(originalRequest);
        } catch (refreshError) {
          // if (refreshError.includes('403')) {
          //   console.log('DAD DADAD ADS')
          // }
          // console.log('-------')
          // console.log(refreshError)
          // console.log('-------')
          // Рефреш не удался — очищаем и перезагружаем
          localStorage.removeItem('jwtToken');
          localStorage.removeItem('refreshToken');
          window.location.reload();
          return Promise.reject(refreshError);
        }
      } else {
        // Нет refresh-токена — выкидываем
        localStorage.removeItem('jwtToken');
        window.location.reload();
      }
    }

    return Promise.reject(error);
  }
);


function extractPathAndLastHash(url) {
  const pathAndHashRegex = /(.*?_)([a-f0-9]{24})$/;
  const match = url.match(pathAndHashRegex);
  return match ? { path: match[1].slice(0, -1), hash: match[2] } : null;
}

class CollectionWrapper {
  constructor(data) {
    this.data = data;
    this.empty = data.length === 0;
  }

  forEach(callback) {
    return this.data.forEach(callback);
  }

  map(callback) {
    return this.data.map(callback);
  }
}
export const axiosFb = axios

export class MyFirestore {
  constructor(baseURL) {
    this.baseURL = baseURL;
  }

  batch() {
    return new FirestoreBatch(this.baseURL);
  }

  commit() {
  }

  collection(name) {
    return new FirestoreCollection(this.baseURL, name);
  }
}

class FirestoreBatch {
  constructor(baseURL) {
    this.baseURL = baseURL;
    this.operations = [];
  }

  set(docRef, data) {
    this.operations.push({
      type: 'set',
      path: docRef.path,
      data,
      id: extractPathAndLastHash(docRef.path).hash
    });
  }

  update(docRef, data) {
    this.operations.push({
      type: 'update',
      path: docRef.path,
      data,
      id: extractPathAndLastHash(docRef.path).hash
    });
  }

  delete(docRef) {
    this.operations.push({
      type: 'delete',
      path: docRef.path,
      id: extractPathAndLastHash(docRef.path).hash
    });
  }

  async commit() {
    try {
      const promises = this.operations.map((op) => {
        console.log(op.path, 'op.path')
        switch (op.type) {
          case 'set':
            return axios.put(`${this.baseURL}/set/${op.path}`, op.data);
          case 'update':
            return axios.put(`${this.baseURL}/${op.path}`, op.data);
          case 'delete':
            return axios.delete(`${this.baseURL}/${op.path}`);
          default:
            return Promise.reject(new Error('Unknown operation type'));
        }
      });

      const results = await Promise.all(promises);
      return results.map((result) => result.data);
    } catch (error) {
      console.error('Error committing batch:', error);
      throw error;
    }
  }
}

class FirestoreCollection {
  constructor(baseURL, path) {
    this.baseURL = baseURL;
    this.path = path;
    this.filters = {};
    this.sortOptions = {};
    this.limitValue = null;
    this.skipValue = null;
  }

  doc(id) {
    if (!id) {
      function generateObjectId() {
        const timestamp = Math.floor(new Date().getTime() / 1000).toString(16);
        const random = 'xxxxxxxxxxxxxxxx'.replace(/[x]/g, () => (Math.random() * 16 | 0).toString(16)).toLowerCase();
        return timestamp + random;
      }

      const id = generateObjectId();

      return {
        id,
        ...(new FirestoreDocument(this.baseURL, `${this.path}_${id}`))};
    }
    return new FirestoreDocument(this.baseURL, `${this.path}_${id}`);
  }

  collection(name) {
    return new FirestoreCollection(this.baseURL, `${this.path}_${name}`);
  }

  batch() {
    return new FirestoreBatch(this.baseURL);
  }

  commit() {
  }

  where(field, op, value) {
    const mongoOp = this.convertOp(op);
    console.log()
    if (mongoOp) {
      this.filters[`where${field}__${mongoOp}`] = String(value);
    }
    return this;
  }

  orderBy(field, direction) {
    this.sortOptions.order = `${field}:${direction}`;
    return this;
  }

  limit(value) {
    this.limitValue = value;
    return this;
  }

  skip(value) {
    this.skipValue = value;
    return this;
  }

  async get() {
    try {
      const params = {...this.filters, ...this.sortOptions};

      if (this.limitValue !== null) {
        params.limit = this.limitValue;
      }
      if (this.skipValue !== null) {
        params.skip = this.skipValue;
      }

      const response = await axios.get(`${this.baseURL}/${this.path}`, {params});

      if (Array.isArray(response.data)) {
        const data = response.data.map((d) => ({
          data() {
            return {...d, id: d._id};
          },
          id: d._id,
        }));

        return new CollectionWrapper(data);
      } else {
        return {
          id: response.data._id,
          data() {
            return {...response.data, id: response.data._id};
          },
        };
      }
    } catch (error) {
      console.error('Error fetching collection:', error);
      throw error;
    }
  }

  async add(data) {
    console.log(data, "ADD JOBS")
    try {
      const response = await axios.post(`${this.baseURL}/${this.path}`, data);
      return {
        id: response.data.insertedId,
      };
    } catch (error) {
      console.error('Error adding document:', error);
      throw error;
    }
  }

  convertOp(op) {
    const opMap = {
      'search': 'search',
      '==': 'eq',
      '!=': 'ne',
      '>': 'gt',
      '>=': 'gte',
      '<': 'lt',
      '<=': 'lte',
      'in': 'in',
      'not-in': 'nin',
      'array-contains': 'contains',
      'customFilters': 'customFilters',
      'array-contains-any': 'array-contains-any'
    };
    return opMap[op];
  }
}

class FirestoreDocument {
  constructor(baseURL, path) {
    this.baseURL = baseURL;
    this.path = path;
  }

  collection(name) {
    return new FirestoreCollection(this.baseURL, `${this.path}_${name}`);
  }

  async get() {
    try {
      const response = await axios.get(`${this.baseURL}/${this.path}`);

      if (Array.isArray(response.data)) {
        const data = response.data.map((d) => ({
          data() {
            return {...d, id: d._id};
          },
          id: d._id,
        }));

        return new CollectionWrapper(data);
      } else {
        return {
          id: response.data._id,
          data() {
            return {...response.data, id: response.data._id};
          },
        };
      }
    } catch (error) {
      console.error('Error fetching document:', error);
      throw error;
    }
  }

  async set(data) {
    try {
      const response = await axios.put(`${this.baseURL}/set/${this.path}`, data);
      return response.data;
    } catch (error) {
      console.error('Error setting document:', error);
      throw error;
    }
  }

  async update(data) {
    try {
      const response = await axios.put(`${this.baseURL}/${this.path}`, data);
      return response.data;
    } catch (error) {
      console.error('Error updating document:', error);
      throw error;
    }
  }

  async delete() {
    try {
      const response = await axios.delete(`${this.baseURL}/${this.path}`);
      return response.data;
    } catch (error) {
      console.error('Error deleting document:', error);
      throw error;
    }
  }
}




// WEBPACK FOOTER //
// ./src/plugins/firb.js